"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SidebarHeader = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _Icon = require("../Icon");

var mapBackgroundTheme = function mapBackgroundTheme(_ref) {
  var bgTheme = _ref.bgTheme,
      palette = _ref.palette;

  switch (bgTheme) {
    case 'default':
      return "".concat(palette.primary.main);

    case 'green':
      return "".concat(palette.green.dark);

    case 'green-gradient':
      return "linear-gradient(to right, ".concat(palette.green.dark, ", ").concat(palette.green.main, ")");

    case 'green-light-gradient':
      return "linear-gradient(to right, ".concat(palette.green.mountainMeadowDark, ", ").concat(palette.green.mountainMeadowLight, ")");

    default:
      return "".concat(palette.primary.main);
  }
};

var useStyles = (0, _styles.makeStyles)(function (_ref2) {
  var palette = _ref2.palette,
      spacing = _ref2.spacing;
  return {
    closeIcon: {
      color: palette.common.white,
      position: 'absolute',
      fontSize: spacing(3),
      top: spacing(3.5),
      right: spacing(3),
      cursor: 'pointer',
      zIndex: 10
    },
    topBarWrapper: {
      height: '100%',
      paddingLeft: spacing(2)
    },
    topBar: {
      position: 'relative',
      height: 80,
      width: '100%',
      backgroundImage: function backgroundImage(_ref3) {
        var bgImage = _ref3.bgImage;
        return bgImage ? "url(".concat(bgImage, ")") : 'none';
      },
      '&::before': {
        position: 'absolute',
        content: "''",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: -1,
        background: function background(_ref4) {
          var bgTheme = _ref4.bgTheme;
          return mapBackgroundTheme({
            bgTheme: bgTheme,
            palette: palette
          });
        }
      }
    }
  };
});

var SidebarHeader = function SidebarHeader(_ref5) {
  var children = _ref5.children,
      _ref5$bgTheme = _ref5.bgTheme,
      bgTheme = _ref5$bgTheme === void 0 ? 'default' : _ref5$bgTheme,
      bgImage = _ref5.bgImage,
      onClose = _ref5.onClose;
  var classes = useStyles({
    bgTheme: bgTheme,
    bgImage: bgImage
  });
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    direction: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative"
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    icon: "times",
    className: classes.closeIcon,
    onClick: onClose
  }), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: classes.topBar
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    wrap: "nowrap",
    className: classes.topBarWrapper
  }, children)));
};

exports.SidebarHeader = SidebarHeader;

var _default = /*#__PURE__*/(0, _react.memo)(SidebarHeader);

exports["default"] = _default;